import React from "react";
import { first } from "lodash-es";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import { getCustomFormattedNameFromObject } from "../../../../services/stringService";
import { getMonthDiff } from "../../../../services/dateFormatter";

const PersonIncomeInfo = ({ memberData, income }) => {
    return (
        <div className="row">
            {income.incomeType === "Salaries/Wages" && (
                <>
                    {income.nameOfEmployer != null && income.nameOfEmployer}
                    {income.nameOfEmployer == null && "Salary"}:
                </>
            )}
            {income.incomeType !== "Salaries/Wages" && <>{income.incomeType}:</>}{" "}
            <>
                ${income.amount}/ {income.frequency}
            </>
        </div>
    );
};

const MemberPersonInfoScreening = ({ member, personInfoScreening, allMembers }) => {
    const memberData = first(personInfoScreening.filter(x => x.personId === member.personId));
    if (memberData == null) {
        return <>Error</>;
    }
    return (
        <div className="mini-section">
            <div className="row">
                <h4>{getCustomFormattedNameFromObject(member, "", true)}</h4>
            </div>
            {memberData.isDisabled && <div className="inline-row">Disabled </div>}{" "}
            <div className="inline-row">
                {memberData.planToFileTaxes && (
                    <>
                        Tax filer
                        {memberData.filesJointlyWith && (
                            <>
                                , filing jointly with{" "}
                                {first(allMembers.filter(x => x.personId === memberData.filesJointlyWith))?.fullName}
                            </>
                        )}
                    </>
                )}
            </div>
            {!memberData.planToFileTaxes && <div className="inline-row">Non-Tax filer</div>}
            {memberData.claimedAsADependentBy != null && (
                <div className="row">
                    Dependent of{" "}
                    {first(allMembers.filter(x => x.personId === memberData.claimedAsADependentBy)).fullName}
                </div>
            )}
            {memberData?.incomeInfo?.doesReceiveIncome && (
                <>
                    <div className="row">
                        <h4>Income</h4>
                    </div>
                    {memberData?.incomeInfo?.incomes?.map(x => <PersonIncomeInfo memberData={memberData} income={x} />)}
                </>
            )}
        </div>
    );
};

// isResponsiblePartyDifferentFromPatient
export const InterviewSidebarPersonInfoScreening = ({ entry, householdMembers, personInfoScreening, ...props }) => {
    let allMembers = [entry?.patient];
    if (entry?.isResponsiblePartyDifferentFromPatient) {
        allMembers = [...allMembers, entry?.responsibleParty];
    }

    if (householdMembers != null) {
        allMembers = [...allMembers, ...householdMembers];
    }
    const patient = entry?.patient;
    return (
        <InterviewSidebarSection title="Financial" {...props}>
            {allMembers.map((x, i) => (
                <MemberPersonInfoScreening
                    key={i}
                    allMembers={allMembers}
                    member={x}
                    personInfoScreening={personInfoScreening}
                />
            ))}
        </InterviewSidebarSection>
    );
};
